var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParticipant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0301 5.90909C13.0301 7.78886 11.5008 9.31818 9.62105 9.31818C7.74128 9.31818 6.21196 7.78886 6.21196 5.90909C6.21196 4.02932 7.74128 2.5 9.62105 2.5C11.5008 2.5 13.0301 4.02932 13.0301 5.90909ZM15.0756 16.1364V13.6368C15.0756 11.6316 13.2408 10 10.9847 10H8.25741C6.00128 10 4.1665 11.6316 4.1665 13.6368V16.1364V16.8182V17.5H15.0756V16.8182V16.1364Z",
    fill: "#A614B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipant);
export default __webpack_public_path__ + "static/media/participant.1f0c03f5c02d8552935deb218e770f13.svg";
export { ForwardRef as ReactComponent };